import CampaignConstants from "./CampaignConstants";
import { Config } from "../../../config/api";

/**
 * Formats a currency value according to the given locale and rules.
 * If the value is greater than or equal to MINIMUM_VALUE_BEFORE_MILLION_TO_BE_ROUNDED,
 * or if the value is between 0 and 1, it formats the value with the given decimal count.
 * Otherwise, it formats the value with 0 decimal places.
 * If the value is greater than or equal to MINIMUM_VALUE_BEFORE_MILLION_TO_BE_ROUNDED,
 * it formats the value with "compact" notation.
 * @param {number} value The value to be formatted.
 * @param {string} currencyCode The currency code to use for formatting.
 * @param {string} [locale] The locale to use for formatting. Defaults to Config.defaultLocale.
 * @param {number} [decimalCount] The number of decimal places to use for formatting. Defaults to 2.
 * @returns {string} The formatted currency value.
 */
export const formatCurrencyByRoundedRules = (value, currencyCode, locale = Config.defaultLocale, decimalCount = 2) => {
  const isAmountWithDecimals =
    value >= CampaignConstants.MINIMUM_VALUE_BEFORE_MILLION_TO_BE_ROUNDED ||
    (value > 0 && value < 1);

  const options = {
    locale,
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: isAmountWithDecimals ? 2 : decimalCount,
    maximumFractionDigits: isAmountWithDecimals ? 2 : decimalCount,
  };

  if (value >= CampaignConstants.MINIMUM_VALUE_BEFORE_MILLION_TO_BE_ROUNDED) {
    options.notation = "compact";
  }

  return new Intl.NumberFormat(locale, options).format(value);
};
